export const iconFontAwesomeLogisticsBus = (
	<i className="fa-solid fa-bus"></i>
);
